<template>
    <div>
        <ion-grid>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="search-view">
                <ion-col >
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3">
                            <ion-label>Taiff Name</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-input id="tariffDescription" v-model="tariffCode" class="form-input" type="text"></ion-input>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Status</ion-label>
                            <div class="border-line-34 margin-top-10">
                                <ion-select 
                                    :value="status"
                                    @ionChange="status = $event.target.value" 
                                    class="form-select select-mobile"
                                    placeholder="Select Status"
                                    interface="action-sheet">
                                    <ion-select-option
                                        v-for="item in statusOptions"
                                        :key="item.code"
                                        :value="item.code"
                                    >
                                        {{ item.description }}
                                    </ion-select-option>
                                </ion-select>
                                <select
                                    class="input-select select-web"
                                    v-model="status"
                                    placeholder="Select Status"
                                    >
                                    <option
                                    v-for="item in statusOptions"
                                        :key="item.code"
                                        :value="item.code"
                                    >{{ item.description }}</option>
                                </select>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <br />
                            <ion-button class="btn-search margin-top-10" @click="searchTariff">Search</ion-button>
                            <ion-button class="btn-clear margin-top-10" @click="clearFields">
                                <ion-icon :icon="refresh"></ion-icon>
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="row-divider"></ion-row>
            <ion-row class="list-view">
                <ion-col>
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                            <ion-label>Tariff Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Rate</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Tax</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Effective From</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Effective To</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                            <ion-label>Status</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="list in tariffList" :key="list">
                        <ion-col size="12" size-md="2">
                            <ion-label class="ext-link" style="cursor: pointer;"  @click="addTariffNameInFilter(list.tariffCode); viewTariffDetails(list)">{{  list.tariffCode }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2" >
                            <div style="display: flex; gap: 4px; flex-wrap: nowrap;">
                                <ion-label v-for="(detail, index) in list.tariffDetails" :key="index">{{ detail.rate }}</ion-label>
                            </div>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                                <ion-label >{{ list.tariffDetails?.[0]?.taxPercentage }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ changeDateFormatWithoutTime(list.effectiveFrom) }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ changeDateFormatWithoutTime(list.effectiveTo) }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                            <ion-label v-bind:class="[{'active': list.status.code == 'A'}, {'in-active': list.status.code == 'I'}]">{{ convertUppercase(list.status.description) }}</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row v-if="norecordsfound">
                <ion-col size="12" class="pagination-info">
                <ion-label class="pagination-info">No records found for the selected filters</ion-label>
                </ion-col>
            </ion-row>
            <ion-row v-else>
                <ion-col size="12" size-md="5">
                <ion-label
                    class="pagination-info"
                >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                </ion-col>
                <ion-col size="12" size-md="7" class="ion-text-right">
                <div class="pagination">
                    <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                    <a class="prev disabled" v-else>Prev</a>
                    <a
                    
                    v-for="page in this.pagesList"
                    :key="page"
                    v-bind:class="{'active': pageNo == page}"
                    @click="loadPage(page)"
                    >{{page}}</a>
                    <a
                    
                    class="next"
                    v-if="this.pageNo < this.totalPages"
                    @click="loadPage(pageNo + 1)"
                    >Next</a>
                    <a class="next disabled" v-else>Next</a>
                </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { refresh, create } from 'ionicons/icons';
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption} from "@ionic/vue";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import { AdminService } from "@/service/admin/admin.service";
import moment from "moment";

export default defineComponent({
    name: 'TariffCreation',
    components:{
        IonIcon, IonGrid, IonRow, IonCol, IonIcon, IonButton, IonSelect, IonSelectOption, IonLabel, IonInput
    },
    data(){
        return{
            refresh,
            create,
            tariffName: "",
            tariffCode: "",
            tariffDescription: "",
            effectiveFrom: '',
            effectiveTo: '',
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            tariffList: [],
            filteredData: "",
            rate: "",
            tax: "",
            status: "",
            "statusOptions": [
                {
                "description": "Active",
                "code": "A"
                },
                {
                "description": "Inactive",
                "code": "I"
                }
            ],
        }
    },

    async mounted() {
        localStorage.removeItem('tariffList');
        var page = localStorage.getItem('tariffPage');
        if (page) {
        this.pageNo = Number(page);
        }
        var search = localStorage.getItem('tariffSearch');
        if (search) {
            search = JSON.parse(search);
            this.tariffCode = search.tariffCode;
            this.status = search.status;
            this.searchTariff();
        } else {
            this.searchTariff()
        }
    },

    methods: {
        convertUppercase(value) {
            return value.toUpperCase()
        },
        addTariffNameInFilter(tariffCode) {
            document.getElementById('tariffDescription').value = tariffCode;
            this.tariffCode = tariffCode;
        },

        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },

        viewTariffDetails(tariff) {
            localStorage.setItem('tariffList', JSON.stringify(tariff));
            this.$router.push("tariffDetails");
        },

        async searchTariff() {
            let existingFilterData = JSON.parse(localStorage.getItem("tariffSearch"))
            let searchFilterData = {
                tariffCode: this.tariffCode,
                status: this.status,
            }
            if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
                localStorage.setItem("tariffSearch",JSON.stringify(searchFilterData));
                this.pageNo = 1;
                localStorage.setItem('tariffPage', this.pageNo);
            } else {
                let pageNo = localStorage.getItem('tariffPage');
                if(pageNo) {
                    this.pageNo = pageNo;
                } else {
                    this.pageNo = 1;
                }
            }
           

            let result = await new AdminService().TariffList(
                this.pageNo,
                this.pageRecords,
                {
                    tariffCode: this.tariffName,
                    rate: this.rate,
                    tax: this.tax,
                    effectiveFrom: this.effectiveFrom,
                    effectiveTo: this.effectiveTo,
                    status: this.status,
                }
            );

            this.filteredData = result.data.details.filter(tariff => {
                    const matchestariffName = this.tariffCode
                        ? tariff.tariffCode.toLowerCase().includes(this.tariffCode.toLowerCase())
                        : true;
                    const matchesStatus = this.status
                    ? tariff.status?.code === this.status
                    : true;
                        

                    return matchestariffName && matchesStatus;
                });


                this.totalRecords = this.filteredData.length;

                this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                this.pageNo
                );

                this.totalPages = new PaginationUtils().getTotalPages(
                this.totalRecords,
                this.pageRecords
                );

                const pageData = { recordNumber: 0, records: 9999999999 };

                try {
                pageData.records = parseInt(this.pageRecords);
                pageData.recordNumber = parseInt(
                    pageData.records * (this.pageNo - 1)
                );

                this.tariffList = this.filteredData.slice(
                    pageData.recordNumber,
                    pageData.records * this.pageNo
                );

                this.norecordsfound = false;
                } catch (error) {
                console.log("Pagination Error:", error);
                }
                
                if(result.data.success) {
                    new ToastUtils().presentToast(result.data.message);
                }
        },

        areFiltersEqual(a, b) {
            return JSON.stringify(a) === JSON.stringify(b);
        },

        clearFields() {
            this.tariffCode = "";
            this.status = "";
            this.pageRecords = 10;
            this.pageNo = 1;
            localStorage.removeItem("tariffSearch");
            localStorage.setItem("tariffPage", 1);
            this.searchTariff();
        },

        async loadPage(page) {
            try {
                this.pageNo = page;
                localStorage.setItem('tariffPage', page);
                this.searchTariff(); 
            } catch (error) {
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        },
    }
})
</script>

<style scoped>

</style>